/* GX Gallery Fix v7 - Bridge + Logging */
(function(){
  var LOG = 'color:#0a0;font-weight:bold';
  var WARN = 'color:#f80;font-weight:bold';
  console.log('%c[GX Gallery] custom.js v7 loaded', LOG);

  var runs = 0;
  function fix() {
    runs++;
    var nav = document.querySelector('.productView-nav');
    if (!nav) {
      if (runs < 80) setTimeout(fix, 100);
      return;
    }
    var sl = nav.querySelector('.slick-list');
    var tr = nav.querySelector('.slick-track');
    if (!sl || !tr) {
      if (runs < 80) setTimeout(fix, 100);
      return;
    }

    var w = nav.offsetWidth;
    if (!w) return;

    var fixed = 0;
    nav.querySelectorAll('.slick-slide img:not(.zoomImg)').forEach(function(img) {
      if (img.naturalWidth && img.naturalHeight) {
        var h = Math.round(w * img.naturalHeight / img.naturalWidth);
        img.style.setProperty('height', h + 'px', 'important');
        img.style.setProperty('width', '100%', 'important');
        fixed++;
      }
    });

    var active = nav.querySelector('.slick-slide.slick-active img:not(.zoomImg)');
    var ah = 0;
    if (active && active.naturalWidth) {
      ah = Math.round(w * active.naturalHeight / active.naturalWidth);
      if (ah > 100) {
        sl.style.setProperty('height', ah + 'px', 'important');
        tr.style.setProperty('height', ah + 'px', 'important');
      }
    }

    if (runs <= 3 || runs % 10 === 0) {
      console.log('%c[GX Gallery] fix run ' + runs + ': ' + fixed + ' imgs, container=' + ah + 'px', LOG);
    }
  }

  function init() {
    fix();
    var nav = document.querySelector('.productView-nav');
    if (!nav) return;

    nav.querySelectorAll('img').forEach(function(img) {
      if (!img.complete) img.addEventListener('load', function() {
        console.log('%c[GX Gallery] img loaded: ' + (img.src||'').split('/').pop().substring(0, 30), LOG);
        fix();
      });
    });

    var sl = nav.querySelector('.slick-list');
    var tr = nav.querySelector('.slick-track');
    if (sl) {
      new MutationObserver(function() {
        console.log('%c[GX Gallery] mutation detected', WARN);
        fix();
      }).observe(sl, { attributes: true, attributeFilter: ['style'] });
      if (tr) new MutationObserver(function() { fix(); }).observe(tr, { attributes: true, attributeFilter: ['style'] });
    }

    try { $(nav).on('afterChange', function(e, s, idx) { console.log('%c[GX Gallery] slide ' + idx, LOG); setTimeout(fix, 30); }); } catch(e) {}

    var rt;
    window.addEventListener('resize', function() { clearTimeout(rt); rt = setTimeout(fix, 100); });
  }

  var poller = setInterval(fix, 100);
  setTimeout(function() { clearInterval(poller); console.log('%c[GX Gallery] polling done', LOG); }, 6000);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
